<template #default>
    <div class="content-wrapper">
        <div class="content-block dx-card responsive-paddings">
            <DxForm id="form1" :form-data="incorporationData">
                <DxGroupItem :caption="$t('productionLines.manageProductionLines')" :col-count="1">
                    <DxSimpleItem name="ManageProductionLinesGrid_">
                        <template #default>
                            <DxDataGrid id="ManageProductionLinesGrid"
                                         :show-borders="true"
                                         :row-alternation-enabled="true"
                                         :hover-state-enabled="true"
                                         @row-inserted="onSave($event)"
                                         @row-updated="onUpdate($event)"
                                         @row-removed="onRemove($event)"
                                         :data-source="ManageProductionLinesData"
                                         ref="dataGridRefKey"
                                         key-expr="Id">
                                <DxColumn
                                    data-field="No"
                                    :caption="$t('productionLines.no')"
                                    :allow-editing="false">
                                </DxColumn>

                                 <DxColumn data-field="Name"
                                           :caption="$t('productionLines.name')">
                                             <DxRequiredRule />
                                 </DxColumn>

                                 <DxColumn data-field="Manufacturing_Model"
                                           :caption="$t('productionLines.model')">
                                             <DxRequiredRule />
                                 </DxColumn>

                                 <DxColumn data-field="Capacity_Per_Day"
                                    format="#,##0.##"
                                    :editorOptions="{ format: '#,##0.##' }"
                                    :caption="$t('productionLines.capacity')">
                                    <DxFormItem editor-type="dxNumberBox" />
                                    <DxRequiredRule />
                                 </DxColumn>

                                 <DxColumn
                                     :caption="$t('productionLines.product')"
                                     data-field="Product_Type">
                                     <DxFormItem/>
                                     <DxLookup
                                         :data-source="ProductOptions"
                                         value-expr="Id"
                                         display-expr="Name"/>
                                         <DxRequiredRule />
                                 </DxColumn>

                                 <DxColumn
                                     :caption="$t('productionLines.facility')"
                                     data-field="Facility">
                                     <DxFormItem/>
                                     <DxLookup
                                         :data-source="FacilityOptions"
                                         value-expr="Id"
                                         display-expr="Name"/>
                                         <DxRequiredRule />
                                 </DxColumn>
                                 
                                 <DxColumn
                                     :caption="$t('productionLines.status')"
                                     data-field="Is_Relevant">
                                     <DxFormItem/>
                                     <DxLookup
                                         :data-source="StatusOptions"
                                         value-expr="Id"
                                         display-expr="Name"/>
                                 </DxColumn>

                                 <DxColumn
                                     :caption="$t('productionLines.description')"
                                     data-field="Description"
                                     :visible="false"             
                                     :show-in-column-chooser="false"> 
                                     <DxFormItem
                                     :col-span="2"
                                     :editor-options="{ height: 70 }"
                                     editor-type="dxTextArea"
                                     />
                                 </DxColumn>

                                 <DxEditing mode="form" :allow-updating="true" :allow-adding="true" />

                                 <DxColumnFixing :enabled="true" />

                                 <DxGroupPanel :visible="true" />

                                 <DxExport :enabled="true"
                                           :formats="['pdf']"
                                           :allow-export-selected-data="true" />

                                 <DxSearchPanel location="before"
                                                :visible="true"
                                                :highlight-case-sensitive="true" />
                                 <DxPager :show-page-size-selector="true" />
                                 <DxPaging :page-size="10" />
                             </DxDataGrid>
                        </template>
                    </DxSimpleItem>
                </DxGroupItem>
            </DxForm>
        </div>
    </div>
</template>

<script>
    import DxForm, {
        DxGroupItem,
        DxSimpleItem,
        DxButtonItem,
        DxLabel,
        DxRequiredRule,
        DxCompareRule,
        DxRangeRule,
        DxStringLengthRule,
        DxPatternRule,
        DxEmailRule,
        DxAsyncRule,
    } from 'devextreme-vue/form'
    import DxItemPanel from "devextreme-vue/tab-panel"
    import DxAutocomplete from 'devextreme-vue/autocomplete'
    import {
        DxDataGrid,
        DxColumn,
        DxEditing,
        DxToolbar,
        DxItem,
        DxFormItem,
        DxLookup,
        DxExport,
        DxSelection,
        DxGrouping,
        DxPager,
        DxPaging,
        DxSearchPanel,
        DxLoadPanel,
        DxMasterDetail,
        DxColumnFixing,
        DxGroupPanel,
    } from 'devextreme-vue/data-grid'

    import DxRadioGroup from 'devextreme-vue/radio-group'

    import DxButton from 'devextreme-vue/button'

    import notify from 'devextreme/ui/notify'

    import dateUtil from '@/helpers/dateUtil'

    import { jsPDF } from 'jspdf'
    import 'jspdf-autotable'
    import { exportDataGrid } from 'devextreme/pdf_exporter'
    import { Workbook } from 'exceljs'
    import { saveAs } from 'file-saver-es'

    import { mapState, mapActions } from 'vuex'

    import { POST_PRODUCTION_LINES,GET_PRODUCTION_LINES,
         GET_MFG_PRODUCT_TYPE,
         GET_REVENUE_SOURCE, GET_FACILITY }
     from '@/store/_actiontypes'

    const dataGridRefKey = "my-data-grid"

    export default {
        components: {
            DxGroupItem,
            DxSimpleItem,
            DxButtonItem,
            DxButton,
            DxRadioGroup,
            DxLabel,
            DxItemPanel,
            DxItem,
            DxDataGrid,
            DxColumn,
            DxEditing,
            DxFormItem,
            DxLookup,
            DxExport,
            DxSelection,
            DxPager,
            DxPaging,
            DxSearchPanel,
            DxMasterDetail,
            DxGrouping,
            DxLoadPanel,
            DxToolbar,
            DxItem,
            DxColumnFixing,
            DxGroupPanel,
            DxRequiredRule,
            DxCompareRule,
            DxPatternRule,
            DxRangeRule,
            DxEmailRule,
            DxStringLengthRule,
            DxForm,
            DxAutocomplete,
            DxAsyncRule,
            notify,
        },

        data() {
            const incorporationData = {}
            const status = [
                {
                    Id: true,
                    Name: 'Active'
                },
                {
                    Id: false,
                    Name: 'Inactive'
                }
            ]

            return {
                StatusOptions: status,
                FacilityOptions: [],
                ProductOptions: [],
                dataOperation: ['New', 'Update'],
                selectedTabIndex: 0,
                isOrderVisible: true,
                dataGridRefKey,
                metaData: {},
                ManageProductionLinesData: [],

                PrintColor: { 'color': '#6caddf', 'text-decoration': 'underline' },

                buttonOptions: {
                    text: 'Save Changes',
                    type: 'default',
                },
                incorporationData
            }
        },

        computed: {
            ...mapState({
                entityId: state => state?.user?.user?.data?.cmm_Entity_Particular_Entity_Id?.id
            }),
            dataGrid: function () {
                return this.$refs.dataGridRefKey.instance
            }
        },

        mounted() {
            this.loadFacilityData()
            this.loadRevenueSourceData()
            this.loadData()
        },

        methods: {
            ...mapActions("application", [
                POST_PRODUCTION_LINES, GET_PRODUCTION_LINES,
                GET_FACILITY, GET_MFG_PRODUCT_TYPE
            ]),

            ...mapActions("payment", [
                 GET_REVENUE_SOURCE
            ]),

            loadFacilityData() {
                this.GET_FACILITY().then(res => {
                    this.FacilityOptions = res.data.map((item, index) => {
                        return {
                            Id: item.id,
                            Name: item.facility_Name
                        }
                    })
                })
                .catch(error => {
                    console.log(error)
                })
            },

            loadRevenueSourceData() {
                this.GET_MFG_PRODUCT_TYPE().then(res => {
                    this.ProductOptions = res.data.map((item, index) => {
                        return {
                            Id: item.id,
                            Name: item.name
                        }
                    })
                })
                .catch(error => {
                    console.log(error)
                })
            },

            loadData() {
                this.GET_PRODUCTION_LINES().then(res => {
                    this.bindData(res.data)      
                })
                .catch(error => {
                    console.log(error)
                })
            },

            bindData(data) {
                this.ManageProductionLinesData = data.map((item, index) => {
                    return {
                        No: index+1,
                        Id: item.id,
                        Name: item.name,
                        Manufacturing_Model: item.manufacturing_Model,
                        Product_Type: item.product_Type,
                        Capacity_Per_Day: item.capacity_Per_Day,
                        Facility: item.facility,
                        Description: item.description,
                        Is_Relevant: item.is_Relevant,
                        CreatedOn: item.created_At
                    }
                })
            },

            onSave(event) {
                let payload = event.data
                payload.IsNew = true
                payload.Entity_Id = this.entityId
                this.POST_PRODUCTION_LINES(payload).then(res => {
                    this.ManageProductionLinesData = []
                    this.loadData()
                    this.$toast.success("Production lines saved successfully!")
                })
                .catch(error => {
                    console.log(error)
                    this.$toast.error("Something went wrong. Try again")
                })
            },

            onUpdate(event) {
                let payload = event.data
                payload._Id = event.data.Id
                this.POST_PRODUCTION_LINES(payload).then(res => {
                    this.ManageProductionLinesData = []
                    this.loadData()
                    this.$toast.success("Production lines updated successfully")
                })
                .catch(error => {
                    console.log(error)
                    this.$toast.error("Something went wrong. Try again")
                })
            },
            
            onRemove(event) {
                let payload = event.data
                payload.IsNew = false
                payload.IsRelevant = false
                payload.Image = this.filePath
                payload.Id_ = event.data.Id
                this.POST_PRODUCTION_LINES(payload).then(res => {
                    this.GridDataSource = []
                    this.loadData()
                    this.$toast.success("Production lines removed successfully")
                })
                .catch(error => {
                    console.log(error)
                    this.$toast.error("Something went wrong. Try again")
                })
            },
            resetInputFiels() {
                this.RegisterOfMembersData = []
                this.CurrentMembersData = []
            }
        }
    }
</script>